//@ts-nocheck
import { Box, VStack } from "@chakra-ui/react";
import { IRootStore } from "../stores";
import JobList from "../tutor-revamp/JobList";
import React from "react";
import { observer } from "mobx-react-lite";

type Props = {
  store: IRootStore;
  agent?: any;
  host?: string;
  booking_key?: string;
};

function JobsPage({
  store,
  agent,
  host = "",
  booking_key = "bookings",
}: Props) {
  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[5, 12]}
      mx="auto"
    >
      <VStack justifyContent="stretch" alignItems="stretch" spacing={[6, 8]}>
        <JobList
          displayFilter={booking_key !== "requests"}
          store={store.jobs}
          agent={agent}
          host={host}
          bookings={store.jobs[booking_key]}
          tutorInfo={store.jobTutorInfo}
        />
      </VStack>
    </Box>
  );
}

export default observer(JobsPage);
